import logo from './logo.svg';
import './App.css';
import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { LinkedInCallback } from './component/my-oauth2/LinkedInCallback.jsx';
import AppMain from './AppMain';

function App() {
  return (
    <BrowserRouter>
       <Routes>
         <Route exact path="/linkedin" element={<LinkedInCallback />} />
         <Route path="/" element={<AppMain />} />
         <Route path="*" element={<AppMain />} />
       </Routes>
    </BrowserRouter>
  );
}

export default App;
